import Swiper from 'swiper';
import {A11y, EffectCreative, Mousewheel, Navigation, Thumbs} from 'swiper/modules';
function buildItemcardThumbsSwiper(wrapper, el) {
    return new Swiper(el, {
        modules: [EffectCreative, A11y, Thumbs, Navigation],
        direction: "horizontal",
        slidesPerView: 3,
        touch: true,
        watchSlidesVisibility: true,
        watchOverflow: true,
        watchSlidesProgress: true,
        allowTouchMove: true,
        spaceBetween: 0,
        breakpoints: {
            320: {
                slidesPerView: 4,
            },
            375: {
                slidesPerView: 5,
            },
            768: {
                slidesPerView: 4,
            },
            1024: {
                slidesPerView: 5,
            },
        },
    });
}
function buildItemcardMainSwiper(wrapper, el, showThumbs, thumbsSwiper = null) {
    return new Swiper(el, {
        modules: [EffectCreative, A11y, Thumbs, Navigation],
        slidesPerView: 1,
        effect: "creative",
        watchOverflow: true,
        navigation: showThumbs ? {
                nextEl: wrapper.querySelector('.swiper-button-next'),
                prevEl: wrapper.querySelector('.swiper-button-prev'),
            }
            : false,
        creativeEffect: {
            prev: {
                translate: [0, 0, -1],
            },
            next: {
                translate: ["100%", 0, 0],
            },
        },
        touch: true,
        thumbs: showThumbs && thumbsSwiper ? {swiper: thumbsSwiper} : undefined,
    });
}

export function initItemcardImages() {
    const wrapper = document.querySelector('.js-itemcardImages');
    if (!wrapper) return;
    wrapper.classList.add("is-loading");
    const mainImages = wrapper.querySelector('.js-itemcardImagesMain');
    const thumbsImages = wrapper.querySelector('.js-itemcardImagesThumbs');
    const thumbsImageSwiperElement = thumbsImages.querySelector('.swiper');
    if (!mainImages) return;
    const showThumbs = thumbsImageSwiperElement && thumbsImageSwiperElement.querySelectorAll(".swiper-slide").length > 1;
    if (!showThumbs) {
        thumbsImages.innerHTML = "";
    }
    const thumbsSwiper = showThumbs ? buildItemcardThumbsSwiper(wrapper, thumbsImageSwiperElement) : null;
    const mainSwiper = buildItemcardMainSwiper(wrapper, mainImages, showThumbs, thumbsSwiper);
    const hideNavigation = () => {
        wrapper.classList.add("is-locked");
    };
    const showNavigation = () => {
        wrapper.classList.remove("is-locked");
    };
    if (showThumbs && thumbsSwiper) {
        if (thumbsSwiper.isLocked === true || typeof thumbsSwiper?.isLocked === 'undefined') {
            hideNavigation();
        } else {
            showNavigation();
        }
    }
    if (showThumbs) {
        thumbsSwiper.on('lock', hideNavigation);
        thumbsSwiper.on('unlock', showNavigation);
    }
    wrapper.classList.remove("is-loading");
    wrapper.classList.add("initialized");
}
